































































import { Component, Vue } from 'vue-property-decorator';
import hexabaseState from '@/store/hexabase';
import {
  customerOptionalForm,
  customerDepartmentRegisterHeader,
  CustomerDepartmentOptionalForm
} from '@/constants/form/customerForm';
import {
  registerFinishText,
  editFinishText,
  editFinishAction,
  customerInitialAction,
  toolTipsMessage
} from '@/constants/customer/customerdepartment';
import {
  FieldChildrenProp,
  ActionFieldSeeting,
  StatusActions,
  ItemActions,
  ActionButtons,
  StatusList,
  FieldsInfo,
  HexaFileFieldResponse
} from '@/services/hexabase/types';

import { customerDepartmentRules } from '@/constants/form/inputCheck';

import Customer from '@/models/customerDepartmentModel';

import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import ActionButtonPanel from '@/components/common/modules/ActionButtonPanel.vue';
import CreateBasicInfoPlusInfo from '@/components/customer/detail/CreateBasicInfoPlusInfo.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';
import IconTextLink from '@/components/common/elements/IconTextLink.vue';
import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';

interface Rules {
  id: string;
  rule: string[];
  referenceField?: {
    id: string;
    rule: string;
  }[];
}
interface FieldValues {
  field_id: string;
  field_name: string;
  dataType: string;
  value: string;
  sizeX: number;
  sizeY: number;
  col: number;
  row: number;
}
@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    ActionButtonPanel,
    CreateBasicInfoPlusInfo,
    TransitionDialog,
    HeaderPanel,
    ExecAction,
    IconTextLink
  }
})
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
export default class CustomerDepartmentEdit extends Vue {
  private projectId = hexabaseState.applicationId;
  private customer = new Customer();
  private headerData = {
    cols: {},
    datas: {} as { [k: string]: any }
  };
  // 各入力フィールド情報格納プロパティ
  private basicFieldsData: Array<FieldChildrenProp> = [];
  private basicFieldCols = '';

  // dbID格納プロパティ
  private mainDsId = '';
  private relatedDsId = '';
  private customerDsId = '';

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private buttonText = this.customer.deepCopy(editFinishText);
  private buttons: Array<{ [k: string]: string | number }> = this.customer.deepCopy(
    editFinishAction
  );

  // APIレスポンス
  private customerBasicInformatioResult: any = [];

  // 初期ステータス
  private displayStatus = '';

  // 編集対象アイテム情報
  private itemId = this.$route.params.id;
  private refCustomerId = '';
  private revNumber = 0;
  private currentData: Array<FieldsInfo> = [];

  // アクション情報格納プロパティ
  private statusButton: Array<StatusActions> = [];
  private statusAction: Array<StatusActions> = [];
  private itemActions: Array<ItemActions> = [];
  private execAllowActions: Array<ActionButtons> = [];
  private execAllowActionsByDetail: Array<ActionButtons> = [];
  private selectAction = '';

  // ステータス情報格納プロパティ
  private statusList: Array<StatusList> = [];
  private statusRules: { [k: string]: Rules[] } = {};

  private buttonCrudType = '';

  // TODO：現状外部ファイルからの取り込みとする、将来的にDB参照に切り替えたい
  private toolTipsText = '';

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      this.mainDsId = hexabaseState.datastoreIds['顧客部署マスタ'];
      this.customerDsId = hexabaseState.datastoreIds['顧客マスタ'];

      // 既存アイテムを取得しアイテム情報・アクション情報を保持
      const basicResult = await this.customer.getItemDetails(
        hexabaseState.applicationId,
        this.mainDsId,
        this.itemId
      );

      // tooltips情報を後設定出来るよう修正
      this.toolTipsText = this.customer.deepCopy(
        toolTipsMessage['customerDepartment_CreateBasicInfoPlusInfo']
      );

      // 削除済みのデータは操作させない
      const wkdata1: Array<FieldValues> = basicResult['field_values'];
      const wkStList: Array<StatusList> = basicResult['status_list'];
      const wkStatus = wkStList.find(
        v => v.status_id === (wkdata1.find(v => v.dataType === 'status')?.value || '')
      )?.status_name;
      this.displayStatus = wkStatus === '有効' ? '' : wkStatus || '';

      if (this.customer.isNullOrUndefined(basicResult.status_actions))
        basicResult.status_actions.forEach((v: StatusActions) => this.statusAction.push(v));
      if (this.customer.isNullOrUndefined(basicResult.item_actions))
        basicResult.item_actions.forEach((v: ItemActions) => this.itemActions.push(v));
      if (this.customer.isNullOrUndefined(basicResult.status_list))
        basicResult.status_list.forEach((v: StatusList) => this.statusList.push(v));

      // ステータス移管に使用するためリビジョン番号を格納
      this.revNumber = basicResult.rev_no;
      // DB登録用データを作成
      this.currentData = basicResult.field_values;
      this.refCustomerId = this.currentData.find(v => v.field_id === 'customer_id')?.value.item_id;
      // マスターデータを取得しグローバル変数に格納
      // await this.customer.getMasterData(this.refCustomerId);
      // this.masterData = this.customer.getMaster();
      for (const key in this.currentData) {
        if (this.currentData[key].value !== undefined && this.currentData[key].value !== null) {
          let value = this.currentData[key].value;
          if (
            this.currentData[key].dataType === 'dslookup' &&
            typeof this.currentData[key].value === 'object' &&
            this.currentData[key].value !== null &&
            this.currentData[key].value.item_id !== undefined
          ) {
            value = this.currentData[key].value.item_id;
          }
          if (this.currentData[key].dataType === 'file') {
            value =
              this.currentData[key].value.length === 0
                ? []
                : (this.currentData[key].value as HexaFileFieldResponse[])
                    .map(file => file.file_id)
                    .filter(v => v);
          }

          this.registData.item[this.currentData[key].field_id] = value;
        }
      }
      const [customerBasicInformatioResult] = await Promise.all([
        this.customer.getItemDetails(
          hexabaseState.applicationId,
          this.customerDsId,
          this.refCustomerId,
          'use_display_id=true'
        ),
        this.getBasicFields()
      ]);
      this.customerBasicInformatioResult = customerBasicInformatioResult;
      this.headerData = this.getHeaderFields(customerDepartmentRegisterHeader);
      const cheaderData = {
        0: this.customerBasicInformatioResult.field_values['customer_id']['value'],
        1: this.customerBasicInformatioResult.field_values['customer_name']['value'],
        2: this.customerBasicInformatioResult.field_values['telephone_number']['value']
      } as { [key: string]: any };
      // Get&set header data
      this.getHeaderData(cheaderData, this.headerData);

      this.execAllowActions = this.statusAction as Array<ActionButtons>;
      this.statusButton = this.customer.statusButtonList(this.execAllowActions, this.currentData);
    } catch (e) {
      console.log(e);
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * 基本情報入力フォームを生成するための設定情報を取得・整形します
   */
  private async getBasicFields() {
    try {
      const initialAction = this.customer.getFormDisplayAction(
        this.itemActions,
        customerInitialAction
      );
      const [inputFields, datas] = await Promise.all([
        this.customer.getFieldsByActionId(this.mainDsId, initialAction!.action_id),
        this.customer.makeFieldsList(this.projectId, this.mainDsId, this.currentData)
      ]);
      // データ登録時の為各フィールドのデータ型を格納
      for (const key in inputFields.action_fields) {
        this.registFieldType[inputFields.action_fields[key].display_id] =
          inputFields.action_fields[key].dataType;
      }
      const data = this.customer
        .addOptionalFormField(
          datas.filter(v => v.dataType !== 'status'),
          this.customer.deepCopy(CustomerDepartmentOptionalForm)
        )
        .map(field => this.customer.inputRestriction(field, inputFields))
        .map(field => this.customer.setSelectAreaItemId(field))
        .map(field => this.customer.setPropsByLocalProperty(field, this))
        .map(field => {
          if (field.dataType === 'dslookup') {
            field.props!.isBtnVisible = false;
          }
          field.props!.isReadonly = true;
          field.props!.isDisabled = true;
          return field;
        });
      this.basicFieldCols = this.customer.getGridStatus(data);
      this.basicFieldsData = data;
    } catch (error) {
      console.log(error);
      this.setError(error);
    }
  }

  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.customer.getGridStatus(formData);
      baseData.datas = formData;
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    }
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasic
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasic(response: any) {
    const index = this.basicFieldsData.findIndex(v => v.display_id === response.name);
    switch (this.basicFieldsData[index].component) {
      case 'MasterSelectControl':
      case 'MasterSelectSetControl':
      case 'MasterSelectMultiControl':
      case 'MasterSelectMultiSetControl':
        this.$set(this.basicFieldsData[index].props!, 'value', { item_id: response.value });
        break;
      default:
        this.$set(this.basicFieldsData[index].props!, 'value', response.value);
    }
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * 基本情報パネルで入力された値を受け取り登録データに渡す
   * @public response - インサート用に整形されたデータ
   * @returns void
   */
  private createBasicData(response: any): void {
    this.registData.item = response;
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async buttonAction(type: any) {
    try {
      // 全要素ReadOnlyアクションか判定
      const targetButton = this.statusButton.find(v => v.display_id === type);
      this.buttonCrudType = targetButton!.crud_type;

      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // アクション毎の見出し要素入力制限反映
      const copy = this.customer.modifyButtonProp(this.execAllowActions, type);
      if (copy !== undefined && copy.length > 0) {
        this.execAllowActions.splice(0, copy.length, ...copy);
      }
      const execAction = this.execAllowActions.find(action => action.display_id === type);
      if (execAction !== undefined) {
        this.selectAction = execAction.display_id;
        // ToDo 自動生成を使用する場合
        const result = (await this.modifyFields(
          this.mainDsId,
          this.basicFieldsData,
          execAction,
          type
        )) as Array<FieldChildrenProp>;
        this.basicFieldsData = result;
      }
    } catch (error) {
      let errorMessage = 'Failed to do something exceptional';
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      this.setError(errorMessage);
    } finally {
      this.statusButton = [
        ...this.customer.statusButtonList(this.execAllowActions, this.currentData, type)
      ];
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: string) {
    switch (type) {
      case 'cancel': {
        this.$router.go(0);
        break;
      }
      case 'exec': {
        try {
          // ローディングをセット
          this.$store.commit('hexabase/setIsLoading', true);
          const response =
            this.buttonCrudType !== '4'
              ? await this.customer.execStatusAction(
                  this.registData,
                  hexabaseState.applicationId,
                  this.mainDsId,
                  this.relatedDsId,
                  this.itemId,
                  this.execAllowActions,
                  this.execAllowActionsByDetail,
                  this.revNumber,
                  this.selectAction
                )
              : await this.customer.registerLinkedItems(
                  hexabaseState.applicationId,
                  this.mainDsId,
                  this.registData
                );

          if (this.buttonCrudType === '4') {
            this.customer.apiErrorHandle('CREATEITEM', response);
            this.buttonText = this.customer.deepCopy(registerFinishText);
            this.buttons.splice(0);
            this.buttons.push({
              id: 1,
              type: 'routing',
              color: 'primary',
              value: '詳細画面へ',
              route: `/customer/departmentedit/${response.item_id}`
            });
          }

          if (response !== undefined && response.text !== undefined && response.text.length > 0) {
            this.buttonText = response.text;
          }
          if (response !== undefined && response.button !== undefined) {
            this.buttons.splice(0);
            this.buttons.push(response.button);
          }
          this.dialogStatus = true;
        } catch (error) {
          let errorMessage = 'Failed to do something exceptional';
          if (error instanceof Error) {
            errorMessage = error.message;
          }
          this.setError(errorMessage);
        } finally {
          this.$store.commit('hexabase/setIsLoading', false);
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  async modifyFields(
    dbId: string,
    data: Array<FieldChildrenProp> | Array<FieldChildrenProp[]>,
    execAction: ActionButtons,
    type: string
  ) {
    const inputFields = await this.customer
      .getFieldsByActionId(dbId, execAction.action_id)
      .then(data => {
        return data;
      });

    data = this.addInputRules(
      data as Array<FieldChildrenProp>,
      inputFields.action_field_settings,
      type
    );
    return this.modifyInputAllow(data, inputFields.action_field_settings) as Array<
      FieldChildrenProp
    >;
  }

  addInputRules(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting },
    type: string
  ) {
    return fields.map(field => {
      if (field.props === undefined) return field;

      const ruleArray = [];

      // Hexa側設定必須項目
      if (fieldSetting[field.field_id] !== undefined) {
        // 必須項目確認
        if (fieldSetting[field.field_id].mandatory) {
          const requiredName = field.component === 'SelectArea' ? 'selectRequired' : 'required';
          ruleArray.push(requiredName);
        }
      }

      // アプリ側設定項目
      if (this.statusRules !== undefined && this.statusRules[type] !== undefined) {
        const row = this.statusRules[type].find(val => val.id === field.display_id);
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }
      // アプリ側設定項目
      if (
        customerDepartmentRules.customerdepart_edit !== undefined &&
        customerDepartmentRules.customerdepart_edit[type] !== undefined
      ) {
        const row = customerDepartmentRules.customerdepart_edit[type].find(
          val => val.id === field.display_id
        );
        if (row !== undefined) {
          ruleArray.push(row.rule);
        }
      }

      if (field.props!['rules'] === undefined) {
        field.props!['rules'] = '';
      }
      if (ruleArray.length > 0) field.props!['rules'] = ruleArray.join('|');
      return field;
    });
  }

  modifyInputAllow(
    fields: Array<FieldChildrenProp>,
    fieldSetting: { [k: string]: ActionFieldSeeting }
  ) {
    return fields.map(field => {
      if (fieldSetting[field.field_id] !== undefined) {
        const row = fieldSetting[field.field_id];
        if (row.update) {
          field.props! = { ...field.props!, ...{ isDisabled: false, isReadonly: false } };
        }
        if (field.dataType === 'dslookup') {
          field.props!.isBtnVisible = true;
          field.props!.isLeftSideInputReadOnly = false;
        }
        field = {
          ...field,
          ...{
            show: row.show,
            update: row.update,
            mandatory: row.mandatory
          }
        };
      }
      return field;
    });
  }

  private setError(errorMessage: string): void {
    if (typeof errorMessage === 'object') errorMessage = this.customer.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 前画面に戻る
   */
  private movePrevious() {
    this.$router.replace({
      name: 'CustomerEdit',
      params: { id: this.refCustomerId },
      query: {}
    });
  }
}
